import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
}

const ErrorBoundary = (props: Props) => {
  const { children } = props;
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      setHasError(true);
      console.error(event.error);
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  if (hasError) {
    return (
      <ErrorContainer>
        <h2 className="h2">오류가 발생했습니다😭 관리자에게 문의 바랍니다.</h2>
        <h6 className="b1">ivyleaguerhr@gmail.com</h6>
      </ErrorContainer>
    );
  }

  return <>{children}</>;
};

export default ErrorBoundary;

const ErrorContainer = styled.main`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
`;
